import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Avatar, Dropdown } from 'antd';

export const CustomAvatar = styled(Avatar)`
  && {
    &.ant-avatar {
      transition: all 0.2s ease-in-out;

      &:hover {
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }
`;

export const CustomDropdown = styled(Dropdown)``;

export const globalDropdownStyles = css`
  .user-menu-dropdown {
    .ant-dropdown-menu {
      min-width: 14rem;
      padding: 1rem;
      background: rgba(203, 223, 204, 0.95);
      border-radius: 1rem;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
      backdrop-filter: blur(8px);

      .ant-dropdown-menu-item {
        color: #5a5b5a;
        font-size: 1rem;
        padding: 0.25rem 1rem;

        &.ant-dropdown-menu-item-disabled {
          cursor: default;
          background: transparent;

          &:hover {
            color: #5a5b5a;
            background-color: transparent;
          }
        }
      }
    }
  }
`;

export const UserMenuContainer = styled.div`
  position: fixed;
  top: 1.5rem;
  right: 2rem;
  z-index: 1000;
`;
